import React from 'react'
import { Button, Modal, UploadingInput } from '../common';
import { convertFileSize, onDownloadDocument } from '../../utils/Helper.js';
import { Download } from 'lucide-react';
import { ReactComponent as Close } from "../../assets/icons/close-circle.svg";
import { LoadingIcon } from "../../components/common/Loading.jsx";
import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg";

function FileUploadPupUp({ handleModalClose, handleSubmit, renderPreview, uploadedFile, handleFileSelect, progress, setClear, clear, setUploadedFile, setPreviewImage, modalHeaderHandle, setProgress, fileUploading = false, title = "Upload CSV File", type = ".csv", showDownloadButton = true, fileTitle = "EnterpriseSampleCSVFile", customTitle="Upload Document", subText="" }) {
    return (
        <Modal
            contentLabel="Help and Support Popup"
            modalHandle={handleModalClose}
        >
            <div className="w-[500px] flex flex-col">
                <div className="mb-3">
                    <h4 className="text-f24 font-bold text-primary text-left">
                        {" "}
                        {customTitle}
                    </h4>
                    {subText && <p className='text-[#787878] text-[12px] text-left'>{subText}</p>}
                </div>
                <form
                    className={`relative border border-slate rounded-lg p-8 mb-6`}
                    onSubmit={handleSubmit}
                >
                    <div className="flex justify-between items-end mb-2">
                        <label
                            htmlFor=""
                            className="block mb-1 text-primary text-f14 font-semibold text-left"
                        >
                            {title}
                        </label>
                        {showDownloadButton && process.env.REACT_APP_SAMPLE_ENTERPRISE_FILE && <Button onClick={() => onDownloadDocument(process.env.REACT_APP_SAMPLE_ENTERPRISE_FILE, null, null, fileTitle)} classes={`relative group py-1 px-1 text-center text-[16px] font-semibold text-[#FB512D] rounded-md  inline-flex items-center justify-center gap-1 cursor-pointer`}
                        ><Download className='w-[16px] h-[16px]' />Download Template</Button>}
                    </div>
                    {fileUploading ? (
                        <LoadingIcon />
                    ) : (
                        !uploadedFile && (
                            <UploadingInput
                                onFileSelect={handleFileSelect}
                                isUploading={true}
                                format={type}
                                clear={clear}
                            />
                        )
                    )}
                    {uploadedFile && (
                        <div className="bg-slate mt-2 p-3 rounded-md relative ">
                            <div className="flex gap-3">
                                <div
                                    className={`flex-auto w-16 ${uploadedFile.type === "application/pdf"
                                        ? "h-20"
                                        : "h-14"
                                        } overflow-hidden`}
                                >
                                    {renderPreview()}
                                </div>
                                <div className="flex flex-col items-start justify-center text-secondarytwo">
                                    <p className="max-w-[300px] text-f14 break-all">{uploadedFile.name}</p>
                                    <div>
                                        <span className="text-f12 text-secondary">
                                            {convertFileSize(uploadedFile.size)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-3 items-center justify-start mt-3">
                                <div className="bg-white h-2 rounded-full overflow-hidden  relative w-full">
                                    <div
                                        className="bg-primary h-full transition-all"
                                        style={{ width: `${progress}%` }}
                                    ></div>
                                </div>
                                <span className="">{progress}%</span>
                            </div>

                            {uploadedFile && (
                                <button
                                    className="absolute right-3 top-3"
                                    onClick={() => {
                                        setClear(!clear);
                                        setUploadedFile("");
                                        setPreviewImage(null);
                                        setProgress(0);
                                    }}
                                >
                                    <Close />
                                </button>
                            )}
                        </div>
                    )}
                </form>
                <div className="flex text-secondary pt-4 w-full gap-4">
                    <Button
                        onClick={fileUploading ? null : modalHeaderHandle}
                        classes={`flex items-center justify-center px-4 py-2 text-white text-f14 rounded w-full ${uploadedFile && !fileUploading ? "bg-primary cursor-pointer" : "bg-disable cursor-not-allowed"}`}
                        isInvalid={!uploadedFile && fileUploading}
                    >
                        {fileUploading ? <Spinner /> : "Continue"}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default FileUploadPupUp